export default __webpack_public_path__ + "static/media/library.4257a223.jpg";